import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { products } from "@/data/products";
import QuickAddButton from "@/components/product/QuickAddButton";

const bestSellerSlugs = ["mushroom-blend", "lions-mane-puro", "cordyceps"];
const benefitMap: Record<string, string> = {
  "lions-mane-puro": "Enfoque y claridad mental",
  "cordyceps": "Energía y rendimiento físico",
  "mushroom-blend": "Bienestar integral diario",
};

const BestSellers = () => {
  const bestSellers = bestSellerSlugs.map(slug => products.find(p => p.slug === slug)).filter(Boolean) as typeof products;

  return (
    <section className="py-16 bg-secondary/30">
      <div className="container">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold uppercase tracking-widest text-primary">Lo que más eligen</p>
          <h2 className="text-3xl sm:text-4xl font-heading font-bold mt-3 text-foreground">
            Más Vendidos
          </h2>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {bestSellers.map((product, idx) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.1 }}
              className="bg-card rounded-2xl border border-border overflow-hidden flex flex-col"
            >
              <Link to={`/producto/${product.slug}`} className="block">
                <div className="aspect-square bg-secondary/50 overflow-hidden">
                  <img
                    src={product.images[0]}
                    alt={product.name}
                    className="w-full h-full object-contain p-6 hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </Link>
              <div className="p-5 flex flex-col flex-1">
                <Link to={`/producto/${product.slug}`}>
                  <h3 className="font-heading font-semibold text-lg text-foreground">{product.name}</h3>
                </Link>
                <p className="text-sm text-muted-foreground mt-1">{benefitMap[product.slug]}</p>

                {/* Stars */}
                <div className="flex items-center gap-1.5 mt-3">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => {
                      const fill = Math.min(1, Math.max(0, product.rating - i));
                      return (
                        <div key={i} className="relative w-4 h-4">
                          <Star className="w-4 h-4 text-border absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: `${fill * 100}%` }}>
                            <Star className="w-4 h-4 text-umbo-gold fill-umbo-gold" />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <span className="text-xs text-muted-foreground">({product.reviewCount})</span>
                </div>

                <p className="text-lg font-bold text-foreground mt-3">${product.price} MXN</p>

                {/* Quick Add */}
                <div className="mt-4">
                  <QuickAddButton product={product} />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BestSellers;
